import React from 'react';
import './btnFilter.css';

const BtnFilter = ({ name }) => {
  return (
    <>
      <button className="btnFilter">{name}</button>
    </>
  );
};

export default BtnFilter;
